import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export interface IFRSAttemptAnswer {
  questionId: string;
  responseOptionId: string;
  answerData?: {
    type: string;
    data: any;
  } | null;
  // An uploaded answer (a spreadsheet worked on in Excel) is stored as an S3
  // URL. This endpoint calls it `answerFileUrl`; the admin attempt-detail route
  // calls the same thing `answerFilePath`, so both are accepted.
  answerFileUrl?: string | null;
  answerFilePath?: string | null;
}

export interface IFRSAttemptAnswersResponse {
  data: IFRSAttemptAnswer[];
}

type GetIFRSAttemptAnswersAPIResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: IFRSAttemptAnswersResponse;
};

export const GetIFRSAttemptAnswers = async (
  ifrsId: string,
  studentToIfrsId: string
): Promise<GetIFRSAttemptAnswersAPIResponse> => {
  try {
    const response = await axios.get(
      `/student/ifrs/${ifrsId}/attempt/${studentToIfrsId}/answers`
    );
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
